package com.eladfinish.bible.contest.screens.search.engine

import com.eladfinish.bible.contest.screens.search.model.SearchMode

data class ChapterSearchInput(
    val bookIndex: Int,
    val rawChapterText: String,
    val preparedRegex: Regex,
    val firstColonIsPartOfRegex: Boolean,
    val searchMode: SearchMode,
    val withNikud: Boolean,
    val withTeamim: Boolean,
    val onlyQri: Boolean,
    val isPremium: Boolean,
)
